import PropTypes from 'prop-types';

import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import PasswordInput from 'components/field/PasswordInput';
import FormItem from 'components/form/FormItem';

import { usePrompt } from 'hooks/usePrompt';

import ActivateStore from '../Fields/ActivateStore';
import BaseUrl from '../Fields/BaseUrl';
import DefaultWarehouseField from '../Fields/DefaultWarehouseField';
import OrderPrefix from '../Fields/OrderPrefix';
import StoreCredentials from '../Fields/StoreCredentials';
import StoreName from '../Fields/StoreName';
import TestConnectionButton from '../Fields/TestConnectionButton';
import * as S from '../SalesChannel.styled';

const SalesChannelDetailsForm = ({
	showToken = true,
	showBaseUrl = true,
	showCredentials = true,
	showSecret = true,
	showWarehouse = true,
	showOrderPrefix = true,
	children
}) => {
	const { t } = useTranslation();
	const {
		formState: { isSubmitting, isDirty, isSubmitSuccessful, isLoading: isFormLoading }
	} = useFormContext();
	const { salesChannel } = useSelector((state) => state.salesChannel);

	usePrompt(isDirty && !isSubmitting && !isSubmitSuccessful);

	const isLoading = isSubmitting || isFormLoading;

	return (
		<S.StoreAccordion header="storeDetails" defaultVisible>
			{/* Basic Fields */}
			<StoreName isLoading={isLoading} />
			{/* Base URL Field */}
			{showBaseUrl && (
				<BaseUrl
					label={
						t(`${salesChannel?.slug}.baseURL`) !== `${salesChannel?.slug}.baseURL`
							? `${salesChannel?.slug}.baseURL`
							: 'baseURL'
					}
				/>
			)}

			{/* Credentials Fields */}
			{showCredentials && <StoreCredentials isLoading={isLoading} required={salesChannel.slug !== 'ikas'} />}

			{/* Token Field */}
			{showToken && (
				<FormItem label={`${salesChannel?.slug}.token`} isLoading={isLoading} required>
					<PasswordInput
						name="token"
						placeholder={t('fieldPlaceholder', { name: t(`${salesChannel?.slug}.token`) })}
					/>
				</FormItem>
			)}

			{/* Secret Field */}
			{showSecret && (
				<FormItem label={`${salesChannel?.slug}.secret`} isLoading={isLoading} required>
					<PasswordInput
						name="secret"
						placeholder={t('fieldPlaceholder', { name: t(`${salesChannel?.slug}.secret`) })}
					/>
				</FormItem>
			)}

			{/* Additional Fields for non-TSoft channels */}
			{salesChannel?.slug !== 'tsoft' && (
				<>
					{showOrderPrefix && <OrderPrefix isLoading={isLoading} />}
					{showWarehouse && <DefaultWarehouseField isLoading={isLoading} />}
				</>
			)}
			{children}
			<ActivateStore isLoading={isLoading} />
			{salesChannel?.testable && <TestConnectionButton />}
		</S.StoreAccordion>
	);
};

SalesChannelDetailsForm.propTypes = {
	showToken: PropTypes.bool,
	showBaseUrl: PropTypes.bool,
	showCredentials: PropTypes.bool,
	showSecret: PropTypes.bool,
	showWarehouse: PropTypes.bool
};

export default SalesChannelDetailsForm;
